import * as React from "react";
import { ImpactTypeSettingsModel } from "./ImpactTypeSettings_model";
import { ITableConfig } from "../../../../../core/table/ITableModel";
import I18n from "../../../../../core/localization/I18n";
import { ITableHeaderModel } from "../../../../../core/table/ITableHeaderModel";
import { AddTableColumnSort } from "../../../../../core/table/TableHeader_view";
import { ITableRowModel } from "../../../../../core/table/ITableRowModel";
import { ButtonTypes } from "../../../../../components/ui/Button";
import { UiActionRenderers } from "../../../../../core/uiAction/IUiAction";
import PermissionsContext from "../../../../../contexts/permissions/PermissionsContext";

export const GetImpactTypeTableConfig = (
  parentModel: ImpactTypeSettingsModel
): ITableConfig<FP.Entities.IImpactType> => {
  const canContribute = PermissionsContext.canContributeOrg(parentModel.organisationId);
  return {
    colHeaders: [
      {
        key: "name",
        content: <h4 className="mb-0">{I18n.t("table.name")}</h4>,
        selector: (obj: FP.Entities.IImpactType) => obj.name,
        action: function (model: ITableHeaderModel) {
          AddTableColumnSort(model, parentModel.tableModel, parentModel.filterModel);
        },
        showSortIcons: true
      },
      {
        key: "weighting",
        content: <h4 className="mb-0">{I18n.t("table.weighting")}</h4>,
        selector: (obj: FP.Entities.IImpactType) => obj.weighting,
        action: function (model: ITableHeaderModel) {
          AddTableColumnSort(model, parentModel.tableModel, parentModel.filterModel);
        },
        showSortIcons: true
      }
    ] as any[],
    actions: canContribute
      ? [
          {
            id: "edit",
            label: I18n.t("phrases.edit"),
            rendersIn: UiActionRenderers.BUTTON,
            componentProps: {
              type: ButtonTypes.LINK
            },
            onAction: (ev, row: ITableRowModel) => {
              parentModel.showFormModal(row.rowObject);
            }
          },
          {
            id: "delete",
            label: I18n.t("phrases.delete"),
            rendersIn: UiActionRenderers.BUTTON,
            componentProps: {
              type: ButtonTypes.LINK
            },
            onAction: (ev, row: ITableRowModel) => {
              parentModel.showConfirmDeleteModal(row.rowObject);
            }
          }
        ]
      : []
  };
};
